import React from "react";
import "./Loader.css";

const Loader = () => {
  return (
    <div className="loader">
      <svg
        space="preserve"
        viewBox="0 0 254.532 254.532"
        xmlns="http://www.w3.org/2000/svg"
        xlinkHref="http://www.w3.org/1999/xlink"
      >
        {/* Your SVG content here */}
      </svg>
    </div>
  );
};

export default Loader;
